// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/print/wcs/Print.css
// module id = 2022
// module chunks = 0